import { Route } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import EmailConfigPage from "../pages/external/EmailConfigPage";
import PhoneConfigPage from "../pages/external/PhoneConfigPage";
import ProtectedRouteV2 from "./ProtectedRouteV2";

const externalServicesRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    {/* Configuración de Correo */}
    <Route
      path="/external-services/email"
      element={
        <>
          <PageTitle title="Configuración de Correo | POS System" />
          <EmailConfigPage />
        </>
      }
    />

    {/* 🔜 Configuración de Teléfono (Twilio) */}
    <Route
      path="/external-services/phone"
      element={
        <>
          <PageTitle title="Configuración de Teléfono | POS System" />
          <PhoneConfigPage />
        </>
      }
    />
  </Route>
);

export default externalServicesRoutes;
